import content from "./content.json";

/**
 * Routes a logged-out visitor can legitimately sit on.
 *
 * Derived from content.json rather than hand-listed in each consumer. Three
 * separate copies of this list had drifted — api.js bounced /faq to /login on
 * the 401 auth probe, and BottomNav rendered the signed-in app nav over the
 * page. Both are invisible in local dev while you happen to be logged in, and
 * both hit every organic search visitor.
 *
 * Add a page to content.json and it becomes public everywhere automatically.
 */
export const PUBLIC_PATHS = new Set([
  ...content.pages.map((p) => p.path),
  "/forgot-password",
  "/headunit",
]);

/** Normalises a location.pathname before matching (tolerates trailing slashes,
 *  which the prerendered `/faq/index.html` routes can produce). */
export function normalizePath(pathname) {
  return pathname.replace(/\/+$/, "") || "/";
}

export function isPublicPath(pathname) {
  const path = normalizePath(pathname);
  return (
    PUBLIC_PATHS.has(path) ||
    // Share links and the head-unit view are prefix matches, not exact ones.
    path.startsWith("/s/") ||
    path.startsWith("/headunit")
  );
}
